// @flow

import React from "react";

type Props = {
    name: string,
    fontAwesome?: boolean
};

export default class Icon extends React.PureComponent<Props> {
    render() {
        const fontAwesome = this.props.fontAwesome || false;

        if (fontAwesome) {
            return this.renderFontAwesome();
        }

        return (
            <span
                className={"Icon glyphicon glyphicon-" + this.props.name}
                aria-hidden="true"
            />
        );
    }

    renderFontAwesome() {
        return (
            <i className={"Icon fa fa-" + this.props.name} aria-hidden="true" />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Icon/Icon.js